import { Money } from './core.models';
import { TransactionResultStatus } from './payment.models';
import { FreeRequestParams } from './shared.models';

export type Sticker = {
  id: string;
  organizationId: string;
  accountId: string;
  balance: Money;
  alertLimit: number;
  negativeBalanceDate: string | null;
  createdAt: string;
  updatedAt: string;
};

export type StickerListParams = FreeRequestParams;

export enum StickerMovementType {
  debit = 'debit',
  credit = 'credit',
  balanceCarryover = 'balance_carryover'
}

export type StickerMovementStatus = {
  status: TransactionResultStatus;
  statusReason: string;
};

export type StickerMovement = {
  id: string;
  organizationId: string;
  accountId: string;
  sticker: Sticker;
  status: StickerMovementStatus;
  relatedObject?: {
    name: string;
    identifier: string;
  };
  amount: Money;
  type: StickerMovementType;
  newBalance: Money;
  createdAt: string;
  updatedAt: string;
};

export type StickerMovementListParams = FreeRequestParams;

export type StickerMovementStatistics = {
  currentBalance: Money;
  data: {
    credit?: Money;
    debit?: Money;
  };
  alertLimit?: number;
};

export type StickerMovementStatisticsParams = {
  startDateTime?: string;
  endDateTime?: string;
};
